import React from "react";
import { createUseStyles } from "react-jss";
import { CDN_URL } from "Constants/CDN";
import LazyImage from "ComponentsUI/Image";

const useStyles = createUseStyles((theme) => ({
	imageElements: {
		display: "flex",
		justifyContent: "flex-start",
		flexWrap: "wrap",
		width: "100%",
		gap: "5px",
	},
	img: {
		height: "20px",
		width: "auto",
	},
}));

export const UnlimitedSocialGrey = ({ socialData }) => {
	const classes = useStyles();

	return (
		<div className={classes.root}>
			<div className={classes.imageElements}>
				{socialData.map(({ key }, index) => {
					return (
						<LazyImage
							width={20}
							height={20}
							src={`${CDN_URL}/images/social/grayscale/${key}.svg`}
							className={classes.img}
							alt={key}
							key={index}
						/>
					);
				})}
			</div>
		</div>
	);
};
